module.exports = __webpack_public_path__ + "img/getcode-2.0134c978.png";